import { CheckboxInput, FormItem, SelectInput } from '@framework/form';
import { RowElement } from '@framework/ui';
import { capitalize } from 'lodash';
import { EnumAiFileTypes } from './AiFileCheckMessage';
import { AiFormCard } from './form/AiFormCard';

// const TFormItem = FormItem as typeof FormItem<IModuleData>;

export interface IAiFileVerifyConfigSectionProps {
  disabled?: boolean;
}
/**
 * Form per la verifica dei file con AI.
 */
export function AiFileVerifyConfigSection(
  props: IAiFileVerifyConfigSectionProps,
) {
  const { disabled } = props;

  const options = Object.values(EnumAiFileTypes).map(value => ({
    label:
      value === EnumAiFileTypes.cie
        ? 'CIE'
        : value === EnumAiFileTypes.cartaIdentita
        ? "Carta d'identità"
        : capitalize(value.replace(/_/g, ' ')),
    value,
  }));

  return (
    <AiFormCard disabled={disabled} title="Verifica Tipo Documento con AI">
      <RowElement>
        <FormItem
          layout={{ removeHelpMargin: true }}
          name="aiCheckDocumentType"
          label="Verifica Documento"
        >
          <CheckboxInput name="aiCheckDocumentType">
            Verifica tipo Documento con AI
          </CheckboxInput>
        </FormItem>
        <FormItem
          layout={{ removeHelpMargin: true }}
          name="aiAllowedDocumentTypes"
          label="Tipi Documento Ammessi"
        >
          <SelectInput
            name="aiAllowedDocumentTypes"
            mode="multiple"
            options={options}
          />
        </FormItem>
      </RowElement>
    </AiFormCard>
  );
}
